import { t } from "@lingui/macro";
import { BankList } from "@src/components/modules/bank";
import { NavigationFinance } from "@src/components/widgets/AppSubNav";
import { DemoModule, Modules } from "@src/components/widgets/DemoModule";
import { MainLayout } from "@src/components/widgets/Layout";
import { withCan } from "@src/utils/components/permissions";
import { createFileRoute } from "@tanstack/react-router";

function Page() {
  return (
    <MainLayout title={t`Bank`} navigation={<NavigationFinance />}>
      <DemoModule module={Modules.Expenses}>
        <BankList />
      </DemoModule>
    </MainLayout>
  );
}

const RouteComponent = withCan({ do: ["bank_read_all"] }, Page);

export const Route = createFileRoute("/bank/")({
  component: RouteComponent,
});
